<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" > Google Map </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><router-link to='/mydashboard'> Map</router-link>
                                </li>
                                
                               
                                
                            </ol>
                        </div>
                        
                      </div>
                   </div>
                </div>
                
            </div>
            <div class="content-body">
               
                <section>
                     <div class="card">
                      
                        <div class="card-header px-0  common_top_title_searchbgst_dock">
                            <div class="container-fluid " >
                                <div class="row row fc_my-05">
                                    <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex mr-1" >
                                            <div class="avatar-content">
                                                <i  class="i_icon_st la-people-carry las lab font-medium-5 "></i>
                                            </div>
                                        </div>
                                        <h4 class="card-title d-inline-flex ml-0 mb-0"> Google Map</h4>
                                    </div>
                                   
                                </div>    
                                    
                            </div>
                        </div>
                      
                      
                        <div class=" col-lg-12 px-0">
                            
                            <div class="card text-center mb-1 p-2">
                                Google Map
                            </div>
                        </div>
                     </div>
                </section>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../constants.js"
import { read, utils } from "xlsx";
import schema from "../utils/schema";
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"

export default({
    name:'googleMap',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        Pagination,
    },
    data() {
        return {
            un:'',
            isLoading: false,
            isShipmentsSyncing: false,
            isMasterListLoading: true,
            pagefeatures:[],
            isFormEdit: false,
            warehouse_master: false,  

            master: {
               
                warehouse_master: {
                    url: "/master/warehouses",
                    list: [],
                    totalcount: 0,
                    pageCount: 0,
                    page: 1,
                    pagelimit: CONSTANT.LIMIT,
                    currPageNum: 0,
                    pageoffset: 1,
                    presignedUrls: [],
                },

             
            },
         
            photoCaptureSound: 'sound/iphone-camera-capture-6448.wav',
        }  
    } ,
    mounted(){
      
        this.getWarehouseMaster()
        
    },
    methods: {
       
     
        toggleMasterCreate() {
            if(this.isFormEdit) {
                this.resetform('warehouse_master')
            }
            this.isFormEdit = false
            this.warehouse_master = !this.warehouse_master; 
        },

    }
})
</script>
<style scoped>
    .alignment{
        margin-left: 20px;
        margin-bottom: 20px;
    }
    .requiredField {
        margin-left: 2px;
        color: red
    }
    #overlay-camera {
      position: fixed;
      display: none;
      width: 100%; 
      height: 100%; 
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,1);
      z-index: 2; 
      cursor: pointer;
    }
    
    .overlay-camera {
      position: fixed;
      display: none;
      width: 100%; 
      height: 100%; 
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,1);
      z-index: 2; 
      cursor: pointer;
    }
    </style>